import React, { FormEvent, useState } from 'react';
import { GenericModalDialog } from '../../../modalDialog/GenericModalDialog';
import { Stack, TextField, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SessionState } from '../../../../reducers/auth/session';
import { AppState } from '../../../../reducers';
import { connect } from 'react-redux';
import DeliveryLocation, { commonDeliveryLocation } from '../../../../models/DeliveryLocation';
import AutocompleteSelector from '../../../Utils/AutocompleteSelector';
import { ProvinceListState } from '../../../../reducers/province/provinceList';
import Province from '../../../../models/Province';

interface AddDeliveryLocationProps {
  onConfirm: (deliveryLocation: DeliveryLocation, event: FormEvent) => void
  onCancel: () => void
  provinceList: ProvinceListState
  provinceCode: number | undefined
  session?: SessionState
}

export const AddDeliveryLocationDialog: React.FC<AddDeliveryLocationProps> = (props) => {
  const { t } = useTranslation('delivery')
  const [delivery, setDelivery] = useState<DeliveryLocation>({ ...commonDeliveryLocation, domicilio: '', principal: -98, codigo_provincia: 0, codigo_cliente: props.session?.byPersonTypeId! })

  const changeAddress = (newAddress: string) => {
    setDelivery({ ...delivery, domicilio: newAddress })
  }

  const changeLocality = (newLocality: string) => {
    setDelivery({ ...delivery, localidad: newLocality })
  }

  const changeZipCode = (newZipCode: string) => {
    setDelivery({ ...delivery, codigopostal: newZipCode })
  }

  const changeTel = (newTel: string) => {
    setDelivery({ ...delivery, telefono: newTel })
  }

  const changeWhoReceives = (newWhoReceives: string) => {
    setDelivery({ ...delivery, quienrecibe: newWhoReceives })
  }

  const changeOpeningHours = (newOpeningHours: string) => {
    setDelivery({ ...delivery, horariodeatencion: newOpeningHours })
  }

  const changeProvince = (newProvince: Province) => {
    if (newProvince && props && props.provinceList) {
      setDelivery({ ...delivery, codigo_provincia: newProvince.codigo_provincia! })
    }
  }

return <GenericModalDialog isOpen={true}
    dialogProps={{ open: true, maxWidth: "lg" }}
    onConfirm={(event) => props.onConfirm && props.onConfirm(delivery!, event!)}
    onCancel={() => props.onCancel && props.onCancel()}
    submit
    title={t('info')}>
    <Stack style={{ display: 'flex', flexDirection: 'column' }}>
        <TextField
          key="address"
          value={delivery.domicilio}
          style={{ margin: '10px 10px' }}
          variant="outlined"
          onChange={event => changeAddress(event.target.value)}
          label={t('address')}
          inputProps={{ maxLength: 50 }}
          required
        />
        <TextField
          key="locality"
          value={delivery.localidad}
          variant="outlined"
          style={{ margin: '10px 10px' }}
          onChange={event => changeLocality(event.target.value)}
          label={t('locality')}
          inputProps={{ maxLength: 50 }}
          required
        />
        <TextField
          key="zipCode"
          value={delivery.codigopostal}
          variant="outlined"
          style={{ margin: '10px 10px' }}
          onChange={event => changeZipCode(event.target.value)}
          label={t('zipCode')}
          inputProps={{ maxLength: 4, pattern: '[0-9]{4}' }}
          required
        />
        <AutocompleteSelector
          label={t("state")}
          name="province"
          //textAdapter={statusPreorderNamesTranslated}
          menuItems={props.provinceList.provinces?.filter(province => props.provinceCode ? props.provinceCode <= 2 ? province.codigo_provincia <= 2 : props.provinceCode === province.codigo_provincia : true)}
          onDataChange={changeProvince}
          value={props.provinceList.provinces?.find( province => province.codigo_provincia === delivery.codigo_provincia)}
          style={{ width: '600px', margin: "10px 10px 20px" }}
          isOptionEqualToValue={(option, value) => option?.codigo_provincia === value?.codigo_provincia}
          getOptionLabel={(option:
            {
              codigo_provincia: number,
              descripcion: string
            }) => `${option?.descripcion} - ${option?.codigo_provincia}`
          }
          required
        />
        <TextField
          key="tel"
          value={delivery.telefono}
          variant="outlined"
          style={{ margin: '10px 10px' }}
          onChange={event => changeTel(event.target.value)}
          label={t('phoneNumber')}
          inputProps={{ maxLength: 50 }}
          required
        />
        <TextField
          key="tel"
          value={delivery.quienrecibe}
          variant="outlined"
          style={{ margin: '10px 10px' }}
          onChange={event => changeWhoReceives(event.target.value)}
          label={t('whoReceives')}
          required
        />
        <TextField
          key="openingHours"
          value={delivery.horariodeatencion}
          variant="outlined"
          style={{ margin: '10px 10px' }}
          onChange={event => changeOpeningHours(event.target.value)}
          inputProps={{ maxLength: 50 }}
          label={t('openingHours')}
        />
      {(props.provinceList?.isFetching) &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
    </Stack>
  </GenericModalDialog>
}


const mapStateToProps = (state: AppState) => ({
  provinceList: state.provinceList,
  session: state.session
})

export default connect(mapStateToProps, null)(AddDeliveryLocationDialog)